<template>
  <section id="about">
    <div class="content">
      <!-- row -->
      <div class="row">
        <!-- Intro -->
        <div v-if="!!intro" :class="intro.col">
          <section-title :title="intro.title" :icon="intro.icon" />
          <div class="intro" v-html="intro.details" />
        </div>

        <!-- Tweet -->
<!--        <div v-if="!!tweet" :class="tweet.col">-->
<!--          <section-title :title="tweet.title" :icon="tweet.icon" />-->
<!--          <tweet-embed :id="tweet.id" />-->
<!--        </div>-->

        <div v-if="!!skills" :class="skills.col">
          <section-title :title="skills.title" :icon="skills.icon" />
          <power-bars :skills="skills" />
        </div>

        <!-- Services -->
        <div v-if="!!services" :class="services.col">
          <section-title :title="services.title" :icon="services.icon" />
          <div class="row">
            <div
                class="col-sm-6 col-md-4"
                v-for="(items, index) in services.details"
                :key="index.toString()"
                v-bind="items"
            >
              <div class="service" :class="items.color">
                <i :class="items.font"></i>
                <h4>{{ items.mainTitle }}</h4>
                <p>{{ items.description }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Process -->
<!--        <div v-if="!!process" :class="process.col">-->
<!--          <section-title :title="process.title" :icon="process.icon" />-->

<!--          <div class="row">-->
<!--            <div-->
<!--                class="col-6 col-sm-4 col-md-2"-->
<!--                v-for="(items, index) in process.details"-->
<!--                :key="index.toString()"-->
<!--                v-bind="items"-->
<!--            >-->
<!--              &lt;!&ndash; process &ndash;&gt;-->
<!--              <div class="process">-->
<!--                <div class="process-box">-->
<!--                  <i :class="items.font"></i>-->
<!--                  <h4>{{ items.mainTitle }}</h4>-->
<!--                </div>-->
<!--                &lt;!&ndash; process &ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <!-- Fact -->
<!--        <div v-if="!!fact" :class="fact.col">-->
<!--          <section-title :title="fact.title" :icon="fact.icon" />-->
<!--          <div class="row">-->
<!--            <div-->
<!--                class="col-sm-6 col-md-3"-->
<!--                v-for="(items, index) in fact.details"-->
<!--                :key="index.toString()"-->
<!--            >-->
<!--              &lt;!&ndash; fun-fact &ndash;&gt;-->
<!--              <div class="fun-fact">-->
<!--                <i :class="items.font"></i>-->
<!--                <h4>{{ items.mainTitle }}</h4>-->
<!--              </div>-->
<!--              &lt;!&ndash; fun-fact &ndash;&gt;-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <!-- Client -->
        <div v-if="!!client" :class="client.col">
          <section-title :title="client.title" :icon="client.icon" />
          <div class="row">
            <div
                class="col-6 col-sm-4 col-md-2"
                v-for="(items, index) in client.details"
                :key="index.toString()"
                v-bind="items"
            >
              <!-- client -->
              <div class="client">
                <a :href="items.link">
                  <img :src="items.image" alt="client" />
                </a>
              </div>
              <!-- client -->
            </div>
          </div>
        </div>

      </div>
      <!-- row -->
    </div>
  </section>
</template>

<script>
    import ABOUTME from "@/json/aboutMe.js";
    import PowerBars from "../components/PowerBars";

    export default {
        name: "AboutMe",
        components: {PowerBars},
        data() {
            return ABOUTME;
        }
    };
</script>
<style>
  .vs-current .twitter-tweet {
    opacity: 1;
  }
  .twitter-tweet {
    opacity: 0;
  }
</style>
